import api from './api';

export const totpService = {
  // Get current user's TOTP status
  getStatus: async () => {
    const response = await api.get('/api/totp/status');
    return response.data;
  },

  // Setup TOTP - Get QR code and manual entry key
  setup: async () => {
    const response = await api.post('/api/totp/setup');
    return response.data;
  },

  // Verify TOTP token and enable TOTP
  verify: async (token) => {
    const response = await api.post('/api/totp/verify', { token });
    return response.data;
  },

  // Disable TOTP
  disable: async (password) => {
    const response = await api.post('/api/totp/disable', { password });
    return response.data;
  },

  // Verify TOTP during login
  verifyLogin: async (userId, token) => {
    const response = await api.post('/api/totp/login-verify', { 
      userId, 
      token 
    });
    return response.data;
  }
};